module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTExLjggMy42bDIuNyAyLjdMNC4xIDE2LjcgMCAxOGwxLjQtNEwxMS44IDMuNnptNS42LTNjLjguNy44IDIgMCAyLjZMMTYgNC42IDEzLjQgMiAxNSAuNmMuNy0uOCAxLjktLjggMi41IDB6IiBmaWxsPSIjMjQzNjQ2IiBmaWxsLXJ1bGU9Im5vbnplcm8iLz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/static/images/mycourses/icon_edit_course.svg
// module id = 312
// module chunks = 0